import { render, staticRenderFns } from "./SwiperMOOCcourses.vue?vue&type=template&id=9b4d17ba&"
import script from "./SwiperMOOCcourses.vue?vue&type=script&lang=js&"
export * from "./SwiperMOOCcourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports